import React from 'react';

export function PrivacyPage() {
  return (
    <div className="page-content">
      <section className="hero is-medium about-hero">
        <div className="hero-body">
          <div className="container has-text-centered">
            <h1 className="title is-2 has-text-white">Privacy Policy</h1>
            <p className="has-text-grey-light">Last updated: May 2026</p>
          </div>
        </div>
      </section>

      <section className="section about-section">
        <div className="container">
          <div className="columns is-centered">
            <div className="column is-8">
              <div className="content" style={{ color: "#c4c4c4" }}>
                <h2 className="has-text-white">1. Introduction</h2>
                <p>Sitech eSports ("we", "our", "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website or use our services.</p>

                <h2 className="has-text-white">2. Information We Collect</h2>
                <p>We may collect the following information:</p>
                <ul>
                  <li><strong>Contact information:</strong> Name, email address, company name, and role when you submit our contact form or request a demo.</li>
                  <li><strong>Usage data:</strong> Information about how you interact with our website, including pages visited, time spent, and referring URLs.</li>
                  <li><strong>Technical data:</strong> IP address, browser type, device information, and operating system.</li>
                </ul>

                <h2 className="has-text-white">3. How We Use Your Information</h2>
                <p>We use the information we collect to:</p>
                <ul>
                  <li>Respond to your enquiries and demo requests</li>
                  <li>Provide and improve our services</li>
                  <li>Send relevant communications about our products (with your consent)</li>
                  <li>Analyse website usage to improve user experience</li>
                  <li>Comply with legal obligations</li>
                </ul>

                <h2 className="has-text-white">4. Data Sharing</h2>
                <p>We do not sell your personal data. We may share information with:</p>
                <ul>
                  <li>Service providers who assist in operating our website and services (e.g. email delivery, hosting)</li>
                  <li>Legal authorities when required by law</li>
                </ul>

                <h2 className="has-text-white">5. Data Retention</h2>
                <p>We retain your personal data only for as long as necessary to fulfil the purposes outlined in this policy, or as required by law.</p>

                <h2 className="has-text-white">6. Your Rights</h2>
                <p>Under applicable data protection laws, you have the right to:</p>
                <ul>
                  <li>Access the personal data we hold about you</li>
                  <li>Request correction of inaccurate data</li>
                  <li>Request deletion of your data</li>
                  <li>Object to or restrict processing of your data</li>
                  <li>Withdraw consent at any time</li>
                </ul>

                <h2 className="has-text-white">7. Cookies</h2>
                <p>Our website may use cookies to enhance your browsing experience. You can control cookie preferences through your browser settings.</p>

                <h2 className="has-text-white">8. Contact Us</h2>
                <p>If you have any questions about this Privacy Policy or wish to exercise your rights, please contact us at <a href="mailto:hello@sitechesports.com" style={{ color: "#6ee7b7" }}>hello@sitechesports.com</a>.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
